module.exports = __webpack_public_path__ + "images/stickers/taco-confused@2x.39d4e060e1fd6bf35d6a.png";